import React from "react";
import styled, { css } from "styled-components";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";

// components
import TNPLogo from "../TNPLogo";
import RightBlock from "../RightBlock";
import HomeLink from "core/SiteHeader/components/HomeLink.js";
import SearchBar from "./SearchBar";

// data
import { RIGHT_BLOCK_WIDTH } from "core/SiteHeader/TabletDesktop/Layout/constants.js";
import {
    GAP,
    TNP_LOGO_WIDTH
} from "core/SiteHeader/TabletDesktop/Layout/constants.js";

// styles
import { convertPxToRem } from "frontend/components/helpers";
const OpacityStyled = styled.div``;

const ContentStyled = styled.div`
    display: flex;
    gap: ${convertPxToRem(GAP)};
    align-items: center;

    ${OpacityStyled} {
        ${({ $opacity }) => {
            return css`
                transition: opacity ${$opacity.speed}ms ease ${$opacity.delay}ms;
                opacity: ${$opacity.value};
            `;
        }}
    }
`;

const FlexibleDiv = styled.div`
    flex: 1;
`;

const HomeLinkStyled = styled(HomeLink)`
    flex: 0 0 ${convertPxToRem(TNP_LOGO_WIDTH)};
`;

const RightBlockStyled = styled(RightBlock)`
    flex: 0 0 ${convertPxToRem(RIGHT_BLOCK_WIDTH)};
`;

// component
export const Content = () => {
    const {
        hasDedlayedSecondRow,
        isCompact,
        animation: {
            styleProps: { opacity }
        }
    } = useSiteHeader();

    const isDisabled = hasDedlayedSecondRow && !isCompact;

    return (
        <ContentStyled $opacity={opacity}>
            <OpacityStyled>
                <HomeLinkStyled isDisabled={!isCompact}>
                    <TNPLogo />
                </HomeLinkStyled>
            </OpacityStyled>
            <FlexibleDiv>
                <SearchBar />
            </FlexibleDiv>
            <OpacityStyled>
                <RightBlockStyled isDisabled={isDisabled} />
            </OpacityStyled>
        </ContentStyled>
    );
};

export default Content;
